/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Dominik Boeck <d.boeck@techdivision.com>
 */

/**
 * If the contract were successfully created, push the information to facebook
 */
const pushPurchaseToFacebook = () => {
  // Push purchase event to the facebook pixel dataLayer
  try {
    if (typeof fbq !== 'undefined') {
      // The average purchase value communicated from fit/one
      const averagePurchaseValue = 350.0;
      /* eslint-disable-next-line */
            fbq('track', 'Purchase', {
        value: averagePurchaseValue,
        currency: 'EUR',
      });
    }
  } catch (error) {
    /* eslint-disable-next-line */
        console.warn(error)
  }
};

export default {
  pushPurchaseToFacebook,
};
